import { Injectable } from '@angular/core';
import {BehaviorSubject, map, Observable, Subject} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {MsalService} from "@azure/msal-angular";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {DomSanitizer} from "@angular/platform-browser";
import {Router} from "@angular/router";
import {AuthDTO} from "../AuthDTO";
import {environment} from "../../../environments/environment";
import {AdminService} from "../../core/service/admin/admin.service";
import {UserDataService} from "../../core/service/user-data/user-data.service";
import {routes} from "../../core/helpers/routes";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  url = environment.baseUrl;

  private currentUserSubject!: BehaviorSubject<AuthDTO | null>;
  private currentUser!: Observable<AuthDTO | null>;
  private readonly _destroying$ = new Subject<void>();
  public routes = routes;

  constructor(private http: HttpClient,
              private router: Router,
              private service: MsalService,
              private matDialog: MatDialog,
              private domSanitizer: DomSanitizer,
              private msalService: MsalService,
              private adminService:AdminService,
              private  userService:UserDataService) {
    this.currentUserSubject = new BehaviorSubject<AuthDTO | null>(null);
    this.currentUser = this.currentUserSubject?.asObservable();
  }



  async getAccessToken(): Promise<string> {
    const account = this.service.instance.getAllAccounts()[0];
    if (account) {
      this.service.instance.setActiveAccount(account);
    }

    const activeAccount = this.service.instance.getActiveAccount();

    try {
      const result = await this.service.acquireTokenSilent({
        scopes: ['api://08aecf67-3ddb-4ccd-9cc6-67a83e1bd8dc/app'],
        ...(activeAccount && { account: activeAccount })
      }).toPromise();

      return result?.accessToken ?? '';
    } catch (err) {
      throw err;
    }
  }

  getUserData() {
    let isDataGet = false;
    let user: AuthDTO = new AuthDTO();
    this.http.get('https://graph.microsoft.com/v1.0/me')
        .subscribe((pro: any) => {
          user.name = pro['displayName'];
          user.job = pro['jobTitle'];
          user.mail = pro['userPrincipalName'];
          this.http.get('https://graph.microsoft.com/v1.0/me/photo/$value', {
            responseType: 'blob',
            headers: new HttpHeaders({'Content-Type': 'image/jpeg'})
          }).subscribe((Blob) => {
            const urlCreator = window.URL || window.webkitURL;
            user.imageToShow = this.domSanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(Blob));
            this.currentUserSubject.next(user);
          }, error => this.currentUserSubject.next(user));
        });
  }


  getUser() {
    return this.currentUserSubject?.asObservable();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  logout() {
    this.currentUser.subscribe((res:any) => {
      sessionStorage.clear();
      localStorage.clear();
      this.clearAllCookies();
      if (res?.mail) {
        const currentAccount = this.service.instance.getAccountByUsername(res?.mail);
        this.service.logout({account: currentAccount});
        localStorage.clear();
      } else {
        this.service.logout();
      }
    });
  }

  clearAllCookies() {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
  }
  public async login(): Promise<void> {
    await this.msalService.initialize();
    await this.msalService.loginRedirect();
  }

  public getVerifyUser(){
    this.adminService.getVerifyUser().pipe().subscribe(data=>{
      console.log("data",data.data)
      this.userService.setUser(data.data)
    })
  }
  public Logout(): void {
    this.router.navigate([routes.signIn]);
  }

}
